<template>
  <v-card outlined light class="rounded-md">
    <v-card-title
      primary-title
      style="background-color: #0d53ee; text-align: left"
      class="pa-6"
      color="white"
    >
      <span
        style="
          font-family: Inter;
          color: white;
          font-size: 18px;
          line-height: 18px;
        "
      >
        <v-icon small color="white" style="margin-top: -5px">mdi-server</v-icon>
        Network
      </span>
    </v-card-title>
    <v-col class="pa-6 py-4">
      <v-row no-gutters>
        <v-col cols="auto" class="py-1">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <div
                style="display: flex; align-items: center; margin-left: -6px"
                class="metric-title"
                v-bind="attrs"
                v-on="on"
              >
                <span
                  style="
                    font-family: Inter;
                    font-size: 0.875rem;
                    font-weight: 600;
                  "
                >
                  IP Address
                </span>
              </div>
            </template>
            <span>Network address of the node</span>
          </v-tooltip>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="py-1">
          <span
            class="copyable-value"
            style="font-family: Inter; font-size: 0.875rem; font-weight: 400"
            @click="copyToClipboard(nodeNetworkAddress, 'IP Address')"
            >{{ nodeNetworkAddress }}</span
          >
        </v-col>
      </v-row>

      <v-row v-if="nodeRoute" no-gutters>
        <v-col cols="auto" class="py-1">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <div
                style="display: flex; align-items: center; margin-left: -6px"
                class="metric-title"
                v-bind="attrs"
                v-on="on"
              >
                <span
                  style="
                    font-family: Inter;
                    font-size: 0.875rem;
                    font-weight: 600;
                  "
                >
                  Route
                </span>
              </div>
            </template>
            <span>Network route for the node</span>
          </v-tooltip>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="py-1">
          <span
            class="copyable-value"
            style="font-family: Inter; font-size: 0.875rem; font-weight: 400"
            @click="copyToClipboard(nodeRoute, 'Route')"
            >{{ nodeRoute }}</span
          >
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="auto" class="py-1">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <div
                style="display: flex; align-items: center; margin-left: -6px"
                class="metric-title"
                v-bind="attrs"
                v-on="on"
              >
                <span
                  style="
                    font-family: Inter;
                    font-size: 0.875rem;
                    font-weight: 600;
                  "
                >
                  Port
                </span>
              </div>
            </template>
            <span>Network port used by the node</span>
          </v-tooltip>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="py-1">
          <span
            class="copyable-value"
            style="font-family: Inter; font-size: 0.875rem; font-weight: 400"
            @click="copyToClipboard(nodePort, 'Port')"
            >{{ nodePort }}</span
          >
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="auto" class="py-1">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <div
                style="display: flex; align-items: center; margin-left: -6px"
                class="metric-title"
                v-bind="attrs"
                v-on="on"
              >
                <span
                  style="
                    font-family: Inter;
                    font-size: 0.875rem;
                    font-weight: 600;
                  "
                >
                  Connection Type
                </span>
              </div>
            </template>
            <span
              >Indicates whether the connection is secure (SSL) or
              insecure</span
            >
          </v-tooltip>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="py-1">
          <span
            class="copyable-value"
            style="font-family: Inter; font-size: 0.875rem; font-weight: 400"
            @click="copyToClipboard(nodeConnectionType, 'Connection Type')"
            >{{ nodeConnectionType }}</span
          >
        </v-col>
      </v-row>
    </v-col>
    <v-snackbar v-model="showToast" :timeout="2000" bottom>
      {{ toastMessage }}
    </v-snackbar>
  </v-card>
</template>

<script>
export default {
  props: {
    node: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showToast: false,
      toastMessage: '',
    };
  },
  computed: {
    nodeNetworkAddress() {
      return this.node ? this.node.network_address : null;
    },
    nodeRoute() {
      return this.node?.route || null;
    },
    nodePort() {
      return this.node ? this.node.port : null;
    },
    nodeConnectionType() {
      return (this.node ? this.node.ssl : false) ? 'Secure' : 'Insecure';
    },
  },
  methods: {
    copyToClipboard(text, fieldName) {
      if (!text) return;
      navigator.clipboard
        .writeText(text.toString())
        .then(() => {
          this.toastMessage = `${fieldName} copied to clipboard`;
          this.showToast = true;
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err);
        });
    },
  },
};
</script>

<style>
.metric-title {
  cursor: help;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  display: inline-flex;
  align-items: center;
}

.metric-title:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.copyable-value {
  cursor: pointer;
}

.copyable-value:hover {
  opacity: 0.7;
}
</style>
